import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66f54416"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "หลักฐานการโอนเงิน", -1))
const _hoisted_2 = { class: "p-grid" }
const _hoisted_3 = { class: "p-col-6 p-md-4" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "p-col-6 p-md-8" }
const _hoisted_6 = { class: "p-m-1 img-container" }
const _hoisted_7 = { class: "img-content f-size-14" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-footer" }, null, -1))
const _hoisted_10 = { class: "p-grid" }
const _hoisted_11 = { class: "p-col-6 p-md-4" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "p-col-6 p-md-8" }
const _hoisted_14 = { class: "p-m-1 img-container" }
const _hoisted_15 = { class: "img-content f-size-14" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img-footer" }, null, -1))
const _hoisted_18 = { class: "panel-upload-box upload-mobile bg-color-secondary" }
const _hoisted_19 = {
  class: "panel-bg-file-img p-mb-2",
  for: "file_upload"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-add" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-plus-circle" }),
  /*#__PURE__*/_createElementVNode("div", { class: "f-size-14 pointer" }, "กดเพื่ออัพโหลดรูปภาพ")
], -1))
const _hoisted_21 = { class: "p-error f-size-14" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Panel, {
      header: "แจ้งโอนเงิน",
      toggleable: true,
      collapsed: _ctx.isCollapsed,
      "onUpdate:collapsed": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isCollapsed) = $event))
    }, {
      icons: _withCtx(() => [
        _createElementVNode("span", {
          class: "text-gray-1 f-size-14",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCollapsed = !_ctx.isCollapsed))
        }, "ดูรายละเอียด")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_1,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listImage, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "d-table p-mt-2",
              key: index + 'fileimagel'
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: item.imageUrl,
                    style: {"height":"auto","width":"100%"},
                    alt: ""
                  }, null, 8, _hoisted_4)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createTextVNode(_toDisplayString(item.name) + " ", 1),
                      _createElementVNode("i", {
                        class: "pi pi-times f-size-12",
                        onClick: ($event: any) => (_ctx.onDeleteImageItem(item))
                      }, null, 8, _hoisted_8)
                    ]),
                    _hoisted_9
                  ])
                ])
              ])
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "d-table p-mt-2",
              key: index + 'fileimagel'
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("img", {
                    src: item,
                    style: {"height":"auto","width":"100%"},
                    alt: ""
                  }, null, 8, _hoisted_12)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createTextVNode(_toDisplayString(_ctx.fileNameLists[index]) + " ", 1),
                      _createElementVNode("i", {
                        class: "pi pi-times f-size-12",
                        onClick: ($event: any) => (_ctx.onDeleteImageItem(index))
                      }, null, 8, _hoisted_16)
                    ]),
                    _hoisted_17
                  ])
                ])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", {
            class: "panel-upload p-mt-2",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setImageIndex(-1)))
          }, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("input", {
                  type: "file",
                  name: "file",
                  ref: "input",
                  id: "file_upload",
                  multiple: "",
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
                  accept: "image/png,image/jpeg"
                }, null, 544)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.uploadSlipMessage), 1)
        ])
      ]),
      _: 1
    }, 8, ["collapsed"])
  ]))
}